// extracted by mini-css-extract-plugin
export default {"wrapper":"rPJ7b","imageWrapper":"AJrRy","image":"z68Yr","textWrapper":"e8Dau","category":"eUDTZ","title":"a2fkr"};